import type { HTMLAttributes } from "react";
import { classNames } from "@app/utils/classNames";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  height?: number | string;
  width?: number | string;
  count?: number;
}

export function Skeleton({ className, height, width, count, style, ...rest }: SkeletonProps) {
  if (count && count > 1) {
    return (
      <div className="ui-skeleton-group" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            {...rest}
            style={{
              ...style,
              height: height ?? "16px",
              width: width ?? "100%",
            }}
            className={classNames("ui-skeleton", className)}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      {...rest}
      style={{
        ...style,
        height: height ?? "100%",
        width: width ?? "100%",
      }}
      className={classNames("ui-skeleton", className)}
    />
  );
}
